var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 100,
    viewBox: "0 0 107 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.58306,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 2.58306 2.58491)",
    fill: "#F69F7F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.58306,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 2.58306 29.4677)",
    fill: "#F69F7F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.58306,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 2.58306 56.3505)",
    fill: "#F69F7F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.58306,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 2.58306 83.2353)",
    fill: "#F69F7F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.58306,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 2.58306 16.0283)",
    fill: "#F69F7F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.58306,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 2.58306 42.9111)",
    fill: "#F69F7F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.58306,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 2.58306 69.7919)",
    fill: "#F69F7F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.58306,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 2.58306 96.6748)",
    fill: "#F69F7F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 17.0596 2.58491)",
    fill: "#F69F7F"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 17.0596 29.4677)",
    fill: "#F69F7F"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 17.0596 56.3505)",
    fill: "#F69F7F"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 17.0596 83.2353)",
    fill: "#F69F7F"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 17.0596 16.0283)",
    fill: "#F69F7F"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 17.0596 42.9111)",
    fill: "#F69F7F"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 17.0596 69.7919)",
    fill: "#F69F7F"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 17.0596 96.6748)",
    fill: "#F69F7F"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5362,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 31.5362 2.58491)",
    fill: "#F69F7F"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5362,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 31.5362 29.4677)",
    fill: "#F69F7F"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5362,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 31.5362 56.3505)",
    fill: "#F69F7F"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5362,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 31.5362 83.2353)",
    fill: "#F69F7F"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5362,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 31.5362 16.0283)",
    fill: "#F69F7F"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5362,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 31.5362 42.9111)",
    fill: "#F69F7F"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5362,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 31.5362 69.7919)",
    fill: "#F69F7F"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5362,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 31.5362 96.6748)",
    fill: "#F69F7F"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 46.0127 2.58491)",
    fill: "#F69F7F"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 46.0127 29.4677)",
    fill: "#F69F7F"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 46.0127 56.3505)",
    fill: "#F69F7F"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 46.0127 83.2353)",
    fill: "#F69F7F"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 46.0127 16.0283)",
    fill: "#F69F7F"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 46.0127 42.9111)",
    fill: "#F69F7F"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 46.0127 69.7919)",
    fill: "#F69F7F"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 46.0127 96.6748)",
    fill: "#F69F7F"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 60.4854 2.58491)",
    fill: "#F69F7F"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 60.4854 29.4677)",
    fill: "#F69F7F"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 60.4854 56.3505)",
    fill: "#F69F7F"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 60.4854 83.2353)",
    fill: "#F69F7F"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 60.4854 16.0283)",
    fill: "#F69F7F"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 60.4854 42.9111)",
    fill: "#F69F7F"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 60.4854 69.7919)",
    fill: "#F69F7F"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 60.4854 96.6748)",
    fill: "#F69F7F"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.962,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 74.962 2.58491)",
    fill: "#F69F7F"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.962,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 74.962 29.4677)",
    fill: "#F69F7F"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.962,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 74.962 56.3505)",
    fill: "#F69F7F"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.962,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 74.962 83.2353)",
    fill: "#F69F7F"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.962,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 74.962 16.0283)",
    fill: "#F69F7F"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.962,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 74.962 42.9111)",
    fill: "#F69F7F"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.962,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 74.962 69.7919)",
    fill: "#F69F7F"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.962,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 74.962 96.6748)",
    fill: "#F69F7F"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 89.4385 2.58491)",
    fill: "#F69F7F"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 89.4385 29.4677)",
    fill: "#F69F7F"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 89.4385 56.3505)",
    fill: "#F69F7F"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 89.4385 83.2353)",
    fill: "#F69F7F"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 89.4385 16.0283)",
    fill: "#F69F7F"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 89.4385 42.9111)",
    fill: "#F69F7F"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 89.4385 69.7919)",
    fill: "#F69F7F"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 89.4385 96.6748)",
    fill: "#F69F7F"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.915,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 103.915 2.58491)",
    fill: "#F69F7F"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.915,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 103.915 29.4677)",
    fill: "#F69F7F"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.915,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 103.915 56.3505)",
    fill: "#F69F7F"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.915,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 103.915 83.2353)",
    fill: "#F69F7F"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.915,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 103.915 16.0283)",
    fill: "#F69F7F"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.915,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 103.915 42.9111)",
    fill: "#F69F7F"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.915,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 103.915 69.7919)",
    fill: "#F69F7F"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.915,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 103.915 96.6748)",
    fill: "#F69F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.2e851f13e4a6a6421da292261d265bb0.svg";
export { ForwardRef as ReactComponent };